$(document).ready(function(){
  
  $('.collection_swatches a').on('mouseenter touchstart',function(){
    $(this).parents('.filter').find('.selected-swatch-color').html($(this).attr('data-swatch-color'));
    $(this).parents('.filter').find('.shoes-leather').html($(this).attr('data-shoes'));
    $(this).parents('.filter').find('.sole-leather').html($(this).attr('data-sole'));
  });
  
  if($('.you-may-also-like-main .seller-col').length == 5){
  	$('.you-may-also-like-main .seller-col:eq(4)').css('display','none')
  }
  $('.product-list .product-wrap a').on('click',function(){
    setTimeout(function(){ location.reload(); }, 1500);
  	
  })
  $('.our-best-seller .seller-box a').on('click',function(){
    setTimeout(function(){ location.reload(); }, 1000);
  	
  })
  $('#shopify-section-search-template .product-wrap a').on('click',function(){
    setTimeout(function(){ location.reload(); }, 1000);
  	
  })

  $(".main_nav .align_right").before($(".header .cart_container").clone());
  $(".main_nav .cart_container").hover(function () {
    $(this).toggleClass("active_link");
  });

  // $('.sublink .icon-down-arrow').click(function(){
  //   if(!$(this).hasClass('active')){
  //     $(this).parents('ul:eq(0)').find('.sublink ul').css('display','none');
  //     $(this).parents('ul:eq(0)').find('.parent-link--true span').removeClass('active');
  //   }
  // })

  $('.toggle-btn').click(function(){
    if($(this).parents('li').hasClass('open')){  
      $(this).parents('li').removeClass('open');
      $(this).next('.sidebar-menu-list').slideUp();
    }else{   
      $(this).closest('.collection-sidebar-menu').find('.spa').removeClass('open');
      $('.sidebar-menu-list').slideUp();      
      $(this).parents('li').addClass('open');
      $(this).next('.sidebar-menu-list').slideDown(); 
    }
  });
  
  $(document).on('click', '.swatch-color .swatch-element', function () {
    var data_id = $(this).attr('data-id');
    console.log('Clicked element data-id:', data_id);

    // Validate if data_id exists
    if (!data_id) {
        console.error('No data-id attribute found on clicked element.');
        return;
    }

    // Update description content
    var targetContent = $('.variant-desc[data-id="' + data_id + '"]');
    console.log('Target content exists:', targetContent.length > 0, targetContent);
    if (targetContent.length > 0) {
        $('.description-detail .des-content').html(targetContent.html());
    } else {
        console.error('No matching .variant-desc for data-id:', data_id);
        return;
    }

    // Build slider HTML
    console.log('closeUpObject[data_id]:', closeUpObject[data_id]);
    if (!closeUpObject[data_id] || !Array.isArray(closeUpObject[data_id])) {
        console.error('closeUpObject is missing or not an array for data-id:', data_id);
        return;
    }

    var mainSliderHtml = '';
    $.each(closeUpObject[data_id], function (index, value) {
        console.log('Image source:', value);
        var altText = closeUpObjectAlt[data_id] ? closeUpObjectAlt[data_id][index] : 'No alt text available';
        console.log('Image alt text:', altText);

        mainSliderHtml += '<div>';
        mainSliderHtml += '<img loading="lazy" src="' + value + '" alt="' + altText + '"/>';
        mainSliderHtml += '</div>';
    });

    console.log('Generated slider HTML:', mainSliderHtml);
    // Here you might append `mainSliderHtml` to the slider container if required.
});


  equalheight('.sameheight');
  equalheight('.two-block-image-heading .inner-box h3');

  if (window.matchMedia("(min-width:799px)").matches) {
    
    $('.bg-wrapper').each(function(){
      var bannerSRC = $(this).find(".bg-img img").attr("src");
      $(this).css('background-image','url(' + bannerSRC + ')');    
    });

    equalheight('.collection-page-wrap .collection-list .product-detail a.product-title');  
    
    // $('.jumbotron').paroller();
  }

  //collection inner page for filter active - FIXED: quotes around collectionName + try/catch to prevent apostrophe crash
  try {
    var collectionName = $('.caption').attr('data-coll-title');
    if (collectionName) {
      $('.sidebar-menu-list').find('li[data-link-title="' + collectionName + '"]').addClass('active');
      $('.active').parents('li').addClass('open');
      $('.active').parents('.sidebar-menu-list').slideDown();
    }
  } catch(e) {}

  
  $('.swatch input').on('change',function(){
    $(this).parents('.swatch').find('.option_title span').html($(this).val());
  })
  
  $('.lifestyle-slide').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    dots: false,
    arrows: false
  });
  
  $('.product-image-slide').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    infinite: true,
    asNavFor: '.product-thumb-slide',
    prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50 L 62,10 L 60,0 Z" class="arrow"></path></svg></button>',
    nextArrow: '<button class="slick-next slick-arrow" aria-label="Next"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50 L 62,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
    responsive: [
    {
      breakpoint: 799,
      settings: {
        arrows: false,
        dots: true
      }
    }
  ]
  });
  $('.product-thumb-slide').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.product-image-slide',
    dots: false,
    centerMode: false,
    infinite: true,
    focusOnSelect: true,
    variableWidth: true,
    prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50 L 62,10 L 60,0 Z" class="arrow"></path></svg></button>',
    nextArrow: '<button class="slick-next slick-arrow" aria-label="Next"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50 L 62,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>'
  });
});


$(window).on('load',function() {

//   $('.swatch-size .option_title span').html($('.swatch-size input[type=radio]:checked').val());  
  $('.swatch-color .option_title span').html($('.swatch-color input[type=radio]:checked').val());

  
  equalheight('.sameheight');
  equalheight('.two-block-image-heading .inner-box h3');

  if (window.matchMedia("(min-width:799px)").matches) {
    $('.bg-wrapper').each(function(){
      var bannerSRC = $(this).find(".bg-img img").attr("src");
      $(this).css('background-image','url(' + bannerSRC + ')');    
    });
    
    equalheight('.collection-page-wrap .collection-list .product-detail a.product-title');
    
    // $('.jumbotron').paroller();
  }
  else{
    $('.bg-wrapper').each(function(){
      var bannerSRC = $(this).find(".bg-img img").attr("src");
      $(this).css('background-image','url(' + bannerSRC + ')');    
    });
  }


 
  if (window.matchMedia("(max-width:798px)").matches) {
     
    $( ".collection-wrapper .banner.page_banner" ).addClass( "mobile-banner" );
    
  } else {
    
    $( ".collection-wrapper .banner.page_banner" ).removeClass( "mobile-banner" );
    
  }

  
  //  Product Gallery Mobile dots slide Start 

  $('.product_gallery .flickity-page-dots').wrap('<div class="custom-dots"></div>');  
  $('.product_gallery .custom-dots .flickity-page-dots').before('<span class="prev-btn"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z"></path></svg></span>');
  $('.product_gallery .custom-dots .flickity-page-dots').after('<span class="next-btn"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" transform="translate(100, 100) rotate(180) "></path></svg></span>');
  $('.product_gallery .custom-dots .flickity-page-dots').wrap('<div class="custom-dots-list"></div>');

//   var pageItem = $(".flickity-page-dots li").parents('.custom-dots').not(".prev-btn,.next-btn");
//   var prev = $(".custom-dots .prev-btn");
//   var next = $(".custom-dots .next-btn");

//   pageItem.click(function() {
//     pageItem.removeClass("is-selected");
//     $(this).not(".prev-btn,.next-btn").addClass("is-selected");
//   });

//   next.click(function() {
//     $('li.is-selected').trigger('click');
//     $('li.is-selected').removeClass('is-selected').next().addClass('is-selected');
//   });

//   prev.click(function() {
//     $('li.is-selected').trigger('click');
//     $('li.is-selected').removeClass('is-selected').prev().addClass('is-selected');
//   });
  var dots_length = $('.product_gallery .flickity-page-dots li').length;
  var height_1 = $('.product_gallery .flickity-page-dots li').outerWidth() * $('.product_gallery .flickity-page-dots li').length;  

  var height_custom = $('.product_gallery .flickity-page-dots li').outerWidth() * 5;  
  $('.custom-dots-list').css('width',height_custom+'px');
  $('.flickity-page-dots').css('transform','translateX(0)');
  $('.custom-dots-list').attr('data-number','0');
  $('.product_gallery .custom-dots .flickity-page-dots').css('width',height_1+'px');
  $('.flickity-page-dots li').each(function(i){
  	$(this).attr('dots-length',i);
  });
  
  var flag_second = true;
  var flag = true;
  $(document).on('click','.next-btn',function() {
    $('.prev-btn').removeClass('disable');
    $('.is-selected').next().trigger( "click" );
    var data_number = $('.custom-dots-list').attr('data-number')   ; 
    if($('.flickity-page-dots .is-selected').prevAll().length >= 5 ){
      if($(this).prev().find('.is-selected').next().attr('dots-length') <= dots_length ){
        data_number = parseInt(data_number) + parseInt($('.product_gallery .flickity-page-dots li').outerWidth());
        $('.flickity-page-dots').css('transform','translateX(-'+data_number+'px)');
        $('.custom-dots-list').attr('data-number',data_number);  
        flag=true;
        flag_second=true;
      }
      else{
        if(flag){
          data_number = parseInt(data_number) + parseInt($('.product_gallery .flickity-page-dots li').outerWidth());
          $('.flickity-page-dots').css('transform','translateX(-'+data_number+'px)');
          $('.custom-dots-list').attr('data-number',data_number);  
          $(this).addClass('disable');
          flag=false;
           flag_second=false;
        }
      }
    }
     
  });  
  
  $(document).on('click','.prev-btn',function() {
    $('.next-btn').removeClass('disable');
    $('.is-selected').prev().trigger( "click" );
    var data_number = $('.custom-dots-list').attr('data-number'); 
    if ($('.is-selected').prev().hasClass('dot') ){
      
      if($('.flickity-page-dots .is-selected').prevAll().length <= 4 ){
        data_number = parseInt(data_number) - parseInt($('.product_gallery .flickity-page-dots li').outerWidth());
        $('.flickity-page-dots').css('transform','translateX(0px)');
        $('.custom-dots-list').attr('data-number','0');
      }
      else{
        data_number = parseInt(data_number) - parseInt($('.product_gallery .flickity-page-dots li').outerWidth());
        $('.flickity-page-dots').css('transform','translateX(-'+data_number+'px)');
        $('.custom-dots-list').attr('data-number',data_number);

      }
      flag_second=true;
      flag=true;
    }
    else{
      if(flag_second){
        data_number = parseInt(data_number) - parseInt($('.product_gallery .flickity-page-dots li').outerWidth());
        $('.flickity-page-dots').css('transform','translateX(0px)');
        $('.custom-dots-list').attr('data-number','0');
        $(this).addClass('disable');
        flag_second=false;
        flag=false;
      }
    }
  });  
  
  
  //  Product Gallery Mobile dots slide End 
  
  $('.swatch-size input').on('change',function(){
    $('.swatch-element').removeClass('active-size')
    $(this).next('.swatch-element').addClass('active-size')
  	$('.add_to_cart').show();
    $('.choose_size').hide();
  });
  
  
  $('.swatch-size input:checked').prop('checked',false);
});




$(window).on('resize',function() {
  equalheight('.sameheight');
  equalheight('.two-block-image-heading .inner-box h3');

  if (window.matchMedia("(min-width:799px)").matches) {
    $('.bg-wrapper').each(function(){
      var bannerSRC = $(this).find(".bg-img img").attr("src");
      $(this).css('background-image','url(' + bannerSRC + ')');    
    });
    equalheight('.collection-page-wrap .collection-list .product-detail a.product-title');
    // $('.jumbotron').paroller();
  }
  
  if (window.matchMedia("(max-width:798px)").matches) {
    $( ".collection-wrapper .banner.page_banner" ).addClass( "mobile-banner" );
  } else {
    $( ".collection-wrapper .banner.page_banner" ).removeClass( "mobile-banner" );
  }
});


equalheight = function(container){
  var currentTallest = 0,
      currentRowStart = 0,
      rowDivs = new Array(),
      $el,
      topPosition = 0;
  $(container).each(function() {

    $el = $(this);
    $($el).height('auto')
    topPostion = $el.position().top;

    if (currentRowStart != topPostion) {
      for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
        rowDivs[currentDiv].height(currentTallest);
      }
      rowDivs.length = 0; // empty the array
      currentRowStart = topPostion;
      currentTallest = $el.height();
      rowDivs.push($el);
    } else {
      rowDivs.push($el);
      currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
    }
    for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
      rowDivs[currentDiv].height(currentTallest);
    }
  });
}


  // $(document).ready(function() {
  //       $('.search_link_desktop .icon-search').hover(
  //           function() {
  //               $('.search_form_cover_suggest').addClass('active_suggest');
  //           },
  //           function() {
  //               $('.search_form_cover_suggest').removeClass('active_suggest');
  //           }
  //       );
  //   });

// -------------------------------------------------------
// Auto-open correct sidebar filter based on current URL
// Works for direct visits AND Turbo/instant navigation
// -------------------------------------------------------
function getFilterKeyword() {
  var p = window.location.pathname.toLowerCase();
  if (p.indexOf('mens-leather-dress-shoes') !== -1) return 'DRESS SHOE';
  if (p.indexOf('oxford') !== -1)                   return 'DRESS SHOE';
  if (p.indexOf('brogue-shoe') !== -1)              return 'DRESS SHOE';
  if (p.indexOf('monk-strap') !== -1)               return 'DRESS SHOE';
  if (p.indexOf('dress-shoe') !== -1)               return 'DRESS SHOE';
  if (p.indexOf('mens-loafer-shoes') !== -1)        return 'LEATHER LOAFER';
  if (p.indexOf('loafer') !== -1)                   return 'LEATHER LOAFER';
  if (p.indexOf('penny') !== -1)                    return 'LEATHER LOAFER';
  if (p.indexOf('tassel') !== -1)                   return 'LEATHER LOAFER';
  if (p.indexOf('leather-sneakers-mens') !== -1)    return 'LEATHER SNEAKER';
  if (p.indexOf('sneaker') !== -1)                  return 'LEATHER SNEAKER';
  if (p.indexOf('low-top') !== -1)                  return 'LEATHER SNEAKER';
  if (p.indexOf('mens-high-tops') !== -1)           return 'LEATHER SNEAKER';
  if (p.indexOf('high-top') !== -1)                 return 'LEATHER SNEAKER';
  if (p.indexOf('mens-leather-lace-up-boots') !== -1) return 'LEATHER BOOT';
  if (p.indexOf('boot') !== -1)                     return 'LEATHER BOOT';
  if (p.indexOf('mens-leather-belts') !== -1)       return 'LEATHER BELT';
  if (p.indexOf('mens-casual-belts') !== -1)        return 'LEATHER BELT';
  if (p.indexOf('mens-dress-belts') !== -1)         return 'LEATHER BELT';
  if (p.indexOf('belt') !== -1)                     return 'LEATHER BELT';
  return '';
}

function autoOpenFilter() {
  var filterKeyword = getFilterKeyword();
  if (!filterKeyword) return;
  setTimeout(function() {
    $('.toggle-btn').each(function() {
      if ($(this).text().trim().toUpperCase().indexOf(filterKeyword) !== -1) {
        $(this).parents('li').addClass('open');
        $(this).next('.sidebar-menu-list').slideDown();
      }
    });
  }, 300);
}

// Run on standard page load
$(document).ready(function() { autoOpenFilter(); });

// Run on Turbo navigation (Shopify instant page loads from mega menu)
document.addEventListener('turbo:load', function() { autoOpenFilter(); });
document.addEventListener('turbo:render', function() { autoOpenFilter(); });
document.addEventListener('page:load', function() { autoOpenFilter(); });

// MutationObserver fallback — watches for sidebar appearing after Turbo navigation
(function() {
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          var hasSidebar = (node.classList && node.classList.contains('collection-sidebar-menu')) ||
                           (node.querySelector && node.querySelector('.collection-sidebar-menu'));
          if (hasSidebar) {
            autoOpenFilter();
          }
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();